import { createSelector } from 'reselect'

export const selectDomain = state => state.get('language').toJS()
export const selectLocale = () => createSelector(selectDomain, state => state.locale)
